import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PersistMessageReferenceResponseModel } from './models/persist-message-reference-response-model';
import { MessageComparisonResult } from './models/message-comparison-result';
import { GridDataResult } from '@progress/kendo-angular-grid';

@Injectable({
  providedIn: 'root',
})
export class PersistMessageReferenceService {
  private baseUrlLocal: string = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  public getPersistMessageReferences(itemId: string, pageIndex: number, pageSize: number): Observable<GridDataResult> {
    return this.http.get<GridDataResult>(`${this.baseUrlLocal}PersistMessageReferences/${encodeURIComponent(itemId)}?pageindex=${pageIndex}&pagesize=${pageSize}`);
  }

  public getPersistMessageContent(referenceId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrlLocal}PersistMessageReferences/message/${encodeURIComponent(referenceId)}`);
  }

  public compare(currentId: number, previousId: number): Observable<MessageComparisonResult> {
    return this.http.get<MessageComparisonResult>(`${this.baseUrlLocal}PersistMessageReferences/compare?currentId=${currentId}&previousId=${previousId}`);
  }
}
